module.exports = __webpack_public_path__ + "static/img/idea_right.6569fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/idea_right.png
// module id = +B90
// module chunks = 3